import { styled } from 'styled-components';

export const ScoutTemplatesButtons = styled.div`
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  gap: ${({ theme }) => theme.sizing.small};
`;
ScoutTemplatesButtons.displayName = 'ScoutTemplatesButtons';

export const ScoutSidebarWrapper = styled.div`
  padding-bottom: 3.5rem;
`;
ScoutSidebarWrapper.displayName = 'ScoutSidebarWrapper';

export const ScoutTabGeneralWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.tiny};
`;
ScoutTabGeneralWrapper.displayName = 'ScoutTabGeneralWrapper';
